import React from 'react';
import { Code, Users, Server, Plug, BarChart3, Headphones } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Code,
  Users,
  Server,
  Plug,
  BarChart3,
  Headphones,
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-blue-400 font-medium text-sm tracking-wider uppercase mb-4 block">
            Our Services
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Comprehensive Technology
            <span className="text-blue-400"> Services</span>
          </h2>
          <p className="text-slate-400 text-lg">
            From concept to deployment, we provide end-to-end technology solutions 
            tailored to enterprise requirements.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative p-8 bg-slate-900/50 rounded-2xl border border-slate-800 hover:border-blue-500/30 transition-all duration-500 hover:-translate-y-2"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Hover Gradient */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-500/5 to-cyan-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative z-10">
                  {/* Icon */}
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-500/10 to-cyan-500/10 rounded-2xl flex items-center justify-center mb-6 group-hover:from-blue-500/20 group-hover:to-cyan-500/20 transition-all duration-300">
                    {IconComponent && (
                      <IconComponent className="w-7 h-7 text-blue-400" />
                    )}
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-blue-300 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed">
                    {service.description}
                  </p>
                </div>

                {/* Corner Accent */}
                <div className="absolute top-4 right-4 w-8 h-8 border-t-2 border-r-2 border-slate-800 rounded-tr-xl group-hover:border-blue-500/30 transition-colors duration-300"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
